import React from 'react';
import { SvgIcon } from '@mui/material';

const QuestionCircleIcon = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	
	return (
		<SvgIcon
			ref={ref}
			viewBox="0 0 16 16"
			sx={sx}
			{...other}
		>
			<g clipPath="url(#clip0_1821_3691)">
				<path 
					d="M7.88671 9.33398V8.91998C7.88639 8.64714 7.95794 8.37902 8.09417 8.14262C8.23039 7.90621 8.42648 7.70986 8.66271 7.57332C9.41337 7.13332 9.67204 6.20198 9.23204 5.45132C8.79204 4.70065 7.86071 4.44198 7.11004 4.88198C6.64337 5.16732 6.33337 5.65865 6.33337 6.22798M8.00004 11.334H7.99471M14.6667 8.00065C14.6667 4.31865 11.682 1.33398 8.00004 1.33398C4.31804 1.33398 1.33337 4.31865 1.33337 8.00065C1.33337 11.6827 4.31804 14.6673 8.00004 14.6673C11.682 14.6673 14.6667 11.6827 14.6667 8.00065Z" 
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1821_3691">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</SvgIcon>
	);
});

QuestionCircleIcon.displayName = 'QuestionCircleIcon';

export default QuestionCircleIcon;
